import { Helmet } from "react-helmet-async";
import '../styles/equipamentos2.min.css';

import Img1 from '../assets/pilates-banner-equip-cadillac.png';
import Img2 from '../assets/banner-404-agrupado.png';
import Img3 from '../assets/banner-ladder-barrel.png';

export default function Home() {

   return ( 
    <>
        <Helmet>
            <title>OsteoVitta Pilates - Criciúma</title>
            <link rel="canonical" href="https://www.osteovitta.com.br/equipamentos/barrel" />
            <meta name="description" content="Descubra os benefícios do Pilates na OsteoVitta em Criciúma." />
        </Helmet>

        <main>

            <section className="equipamentos-pilates">

                <div className="equip-cadillac-banner-box">

                    <div className="equip-pilates-banner-img">
                        <img className="hide--mobile" src={Img1}/>
                        <img className="hide--desk" src={Img2}/>
                    </div>

                    <div className="equip-pilates-title">
                        <h1> Equipamento <br/><span className="text-bold"> Ladder Barrel</span> </h1>
                        <img className="cadillac-img" src={Img3}/>
                    </div>

                </div>

                <div className="pilates-cadillac-title">
                    <h2>
                        O Laddar Barrel ajuda a isolar a musculatura<br/> profunda de controle de postura e desafia o<br/> corpo
                        em todos os planos de movimento<br/>
                    </h2>
                </div>

                <div className="chair-text pilates-cadillac-text">

                    <span>
                        A tradução literal do nome deste equipamento é Escada Barril. Assim, como o nome diz, esta peça de
                        equipamento de Pilates consiste em alguns degraus como uma escada e uma superfície arredondada como um
                        barril nas quais uma infnidade de exercícios de alongamento, fortalecimento e flexibilidade podem ser
                        realizados. O barril é separado da escada por uma base deslisante que pode ser ajustada para acomodar
                        diferentes tamanhos de corpos e comprimento de pernas. Os degraus da escada, de 4 a 6 no total, são também
                        ajustáveis para facilitar variados níveis de exercícios.<br/><br/>

                        O Laddar Barrel do Pilates ajuda a isolar a musculatura profunda de controle de postura e desafia o corpo
                        em todos os planos de movimento. Por exemplo, um exercício onde você está sentada no barril, virado de
                        frente para a escada com os pés seguros nos degraus, então você arqueia as costas para trás por cima do
                        barril com suas vértebras seguindo o seu contorno e então ativa os abdominais profundos para retornar a
                        posição inicial de uma forma controlada. Foco mental é a chave para executar isto de forma segura e
                        efetiva. Outros exercícios tem você olhando para o outro lado, com sua barriga no barril, dando a você um
                        alongamento da coluna suportado, o que ajuda a aliviar a tensão.<br/><br/>
                    </span>
                </div>

            </section>

        </main>
    </> 
  );
}